// src/components/ForgotPassword.vue


<template>
  <div class="page-header" >
    <div
      class="page-header-image"
      style="background-image: url('/img/street-map.jpg')"
    ></div>
    <div class="content">
      <div class="container">

        <div class="col-md-5 ml-auto mr-auto" style="margin-top: 100px">
          <card class="card-signup" header-classes="text-center" color="orange">

            <div class='formcontainer' v-if="formState === 'requestCode'">
              <h3 class="card-title title-up header-classes='text-center'">FORGOT PASSWORD</h3>
              <p>No problem. Just mention your email below and we are going to send you a confirmation code. With this code you can set a new password. </p>
              <fg-input
                class="no-border input-lg"
                addon-left-icon="now-ui-icons users_circle-08"
                placeholder="E-Mail"
                v-model='form.email'
                v-on:keyup="inputChanged"
              >
              </fg-input>

              <div id="infoArea">{{info_text}}</div>
              <div class="card-footer text-center">
                <n-button v-on:click='forgotPassword' type="neutral" round size="lg">Send Confirmation Code</n-button>
              </div>
            </div>
            <div class='formcontainer' v-if="formState === 'confirmMailAndSetPW'">
              <h3 class="card-title title-up">SET NEW PASSWORD</h3>
              <fg-input
                id ="authCodeInput"
                class="no-border input-lg"
                addon-left-icon="now-ui-icons text_caps-small"
                placeholder="Authentication Code"
                v-model='form.authCode'
                v-on:keyup="validationInputChanged"
              >
              </fg-input>

              <fg-input
                id="newPasswordInput"
                class="no-border input-lg"
                addon-left-icon="now-ui-icons text_caps-small"
                placeholder="New Password"
                type='password'
                v-model='form.password'
                v-on:keyup="inputChanged"
              >
              </fg-input>

              <div>{{change_info_text}}</div>

              <div class="card-footer text-center">

                <n-button id="changePWButton" v-on:click='confirmMailAndSetPW' type="neutral" round size="lg">Change Password</n-button>
                <n-button id="toLoginButton" v-on:click="$router.push('/auth')" type="neutral" round size="lg" style="display:none">To Sign in</n-button>


              </div>

            </div> <!-- close formcontainer confirmMailAndSetPW-->
          </card>
        </div>

      </div> <!-- close container -->
    </div> <!-- close content -->
    <main-footer></main-footer>
  </div> <!-- close page-header -->

</template>

<script>
import { Auth } from 'aws-amplify'
import { AmplifyEventBus } from 'aws-amplify-vue'
import { Card, Button, FormGroupInput } from '@/components';
export default {
  name: 'forgotPassword',
  components: {
    Card,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput
  },
  data() {
    return {
      formState: 'requestCode',
      form: {
        email: '',
        password: ''
      },
      info_text: '',
      change_info_text: ''
    }
  },
  methods: {
    async forgotPassword() {
      this.$Amplify.Auth.forgotPassword(this.form.email)
        .then(() => {
          //this.sent = true;
          //this.logger.info('forgotPassword success');
          this.formState = 'confirmMailAndSetPW'; // switches email dialog to Verification and set new password
        })
        .catch(err => {
          this.info_text = this.$Amplify.I18n.get(err.message || err)
        })



    },
    async confirmMailAndSetPW() {
      this.$Amplify.Auth.forgotPasswordSubmit(this.form.email, this.form.authCode, this.form.password)
        .then(() => {
          //this.sent = true;
          //this.logger.info('forgotPassword success');
          this.change_info_text = "Password change was successful. You can sign in to your account now."
          document.getElementById("changePWButton").style.display = "none";

          document.getElementById("toLoginButton").style.display = "inline";
          data => console.log(data);
        })
        .catch(err => {
          this.change_info_text = this.$Amplify.I18n.get(err.message || err)

        })


    },

    inputChanged: function (event) {
      this.info_text = '';
    },
    validationInputChanged: function (event) {
      this.change_info_text = '';
    }


  }
}
</script>
